export default "__VITE_ASSET__D10gmSYR__"